export const mainRouteInitial = "HarshSanghavi";